
















































import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'

@Component
export default class ModalFileUploadWarning extends Vue {
  @Prop() visible: boolean
  @Prop() title: string
  @Prop() subtitle: string
  @Prop() description: string
  @Prop() tip: string

  @Emit('close')
  closeModal() {}

  @Emit('esc')
  escClick() {}

  show: boolean = false

  @Watch('visible')
  onVisibilityChange(visible: boolean) {
    this.show = visible
  }

  close() {
    this.$emit('close')
  }

  esc() {
    this.$emit('esc')
  }
}
